import React from 'react';
import axios from 'axios';
import { orderBy } from 'lodash';

import TableRequested from './TableRequested';
import { API_PATH } from '../../../constants';
import Loader from '../../general/Loader';

class ExtraShiftRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timeUnit: 'shift',
      dutyRequest: null,
      dropdownOpen: false,
      sortByConstraint: 1,
      selectedConstraint: null,
      constraints: [],
      canRespondAny: false
    };

    this.getDutyRequest();
  }

  getDutyRequest = () => {
    axios
      .get(`${API_PATH}/duty_requests/${this.props.duty_request_id}`)
      .then(response => {
        const { data } = response;
        data.duty_exchange_intervals = orderBy(data.duty_exchange_intervals, ['state']);
        const canRespondAny = data.duty_exchange_intervals.some(interval => interval.can_respond);
        this.setState({
          dutyRequest: data,
          canRespondAny
        });
        this.loadContractStatistics(data);
      })
      .catch(error => {
        console.log(error);
      });
  };

  // load contract statistics for the progress bar, balance and contract
  // constraint statistics table
  loadContractStatistics = data => {
    const urlFormat = `${API_PATH}/users/{0}/contract_statistics?time_unit=${this.state.timeUnit}`;
    const contractRequests = data.duty_exchange_intervals.map(interval =>
      axios.get(String.format(urlFormat, interval.user.id)).catch(error => {
        console.log(error);
      })
    );

    // when all requests have been loaded, update the candidates by setting a
    // new attribute on them with their contract statistics, if any
    Promise.all(contractRequests)
      .then(responses => {
        const contractsPerUser = {};
        for (const response of responses) {
          if (!response || !response.data[0]) continue;
          // for now, we'll only show the first active contract
          for (const constraintEvaluation of response.data[0].constraint_evaluation) {
            const { constraints } = this.state;
            constraints.push(constraintEvaluation.name);
            this.setState({ constraints: [...new Set(constraints)] });
          }
          [contractsPerUser[response.data[0].user_id]] = response.data;
        }
        const dutyRequest = data;
        dutyRequest.duty_exchange_intervals = data.duty_exchange_intervals.map(interval => {
          // find the response with contract statistics for this user
          const contractStatistics = contractsPerUser[interval.user.id] || {};
          // extend the candidate object with the contractStatistics property
          return { ...interval, contractStatistics };
        });
        this.setState({ dutyRequest });
      })
      .catch(error => {
        console.log(error);
      });
  };

  handleSelect = selectedConstraint => {
    this.setState({ selectedConstraint });
  };

  reverseSort = () => {
    this.setState({ sortByConstraint: this.state.sortByConstraint * -1 });
  };

  render = () => {
    let dutyRequest = { ...this.state.dutyRequest };
    if (!dutyRequest.id) return <Loader />;
    if (this.state.selectedConstraint) {
      dutyRequest = {
        ...this.state.dutyRequest,
        duty_exchange_intervals: this.state.dutyRequest.duty_exchange_intervals.filter(interval =>
          (interval.contractStatistics.constraint_evaluation || []).find(
            evaluation => evaluation.name === this.state.selectedConstraint
          )
        )
      };
      dutyRequest.duty_exchange_intervals.sort((a, b) => {
        const aEvaluation = (a.contractStatistics.constraint_evaluation || []).find(
          evaluation => evaluation.name === this.state.selectedConstraint
        );
        const bEvaluation = (b.contractStatistics.constraint_evaluation || []).find(
          evaluation => evaluation.name === this.state.selectedConstraint
        );
        return aEvaluation.value - bEvaluation.value;
      });
      if (this.state.sortByConstraint === -1) {
        dutyRequest.duty_exchange_intervals.reverse();
      }
    }
    return (
      <TableRequested
        {...this.props}
        dutyRequest={dutyRequest}
        constraints={this.state.constraints}
        handleSelect={this.handleSelect}
        selectedConstraint={this.state.selectedConstraint}
        sortByConstraint={this.state.sortByConstraint}
        reverseSort={this.reverseSort}
        canRespondAny={this.state.canRespondAny}
      />
    );
  };
}

export default ExtraShiftRequest;
